import WorldMap from "@/components/WorldMap";

/**
 * Shared page hero background — subtle world map + soft radial glow on cream.
 * Use inside any hero section as an absolutely positioned layer.
 */
export default function PageHeroBackground({ opacity = 0.25 }) {
  return (
    <>
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ opacity }}
        data-testid="page-hero-map"
      >
        <WorldMap variant="light" />
      </div>
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 75% 35%, rgba(18,63,51,0.06) 0%, transparent 55%), radial-gradient(circle at 15% 85%, rgba(228,225,216,0.4) 0%, transparent 45%)",
        }}
      />
    </>
  );
}
